import React from "react";
import PropTypes from "prop-types";
import { LinearProgress, Typography, Box, makeStyles } from "@material-ui/core";

export default function LinearProgressFill(props) {
  const primaryColor =
      /*props.value < 50 ? "#303f9f" : props.value < 75 ? "#ffbb33" : "#ff4444";  Antigua validación*/
      //Validacion nueva
      props.value <= 30 ? "#349f30" : props.value >=31 && props.value <=60 ? "#ffbb33" : "#ff4444";

  const progressStyle = makeStyles(() => ({
    barColorPrimary: { backgroundColor: primaryColor },
  }));

  const classes = progressStyle();
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress
          variant="determinate"
          {...props}
          classes={{
            barColorPrimary: classes.barColorPrimary,
          }}
        />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressFill.propTypes = {
  value: PropTypes.number.isRequired,
};
